import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable, firstValueFrom } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { EventDataService } from "..";
import { TranslocoService, provideTranslocoScope } from "@jsverse/transloco";

@Component({
    selector: "event-linkable",
    templateUrl: "./event-linkable.component.html",
    styleUrls: ["./event-linkable.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("event")],
})
export class EventLinkableComponent extends ItemLinkableBase {
    private _eventDS = inject(EventDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translocoService = inject(TranslocoService);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._eventDS.hasAccessToEvent(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.EventDetail,
                item.guid,
                `(E) ${item[this.displayValueProp]}`
            );
        } else {
            // Nothing in this template uses the transloco pipe/directive, so the lazy scope
            // is not loaded yet and a synchronous translate() would return the raw key.
            await firstValueFrom(
                this._translocoService.load(`event/${this._translocoService.getActiveLang()}`)
            );
            this._toastr.warning(
                this._translocoService.translate("event.eventLinkable.notEnoughRights")
            );
        }
    }
}
